import view from './view.js'

var index = {
    data() {

    },
    modules: {
        view
    }
}

export default index;